import { render, staticRenderFns } from "./facial.vue?vue&type=template&id=31deecd6&scoped=true&"
import script from "./facial.vue?vue&type=script&lang=js&"
export * from "./facial.vue?vue&type=script&lang=js&"
import style0 from "./facial.vue?vue&type=style&index=0&id=31deecd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31deecd6",
  null
  
)

export default component.exports